import { SentryConfig } from '@sequencehq/utils'
import { getSentryConfig } from 'features/sentry/getSentryConfig'

const { environment } = getSentryConfig()

const isProduction = ['production'].includes(environment)
const isSandbox = ['sandbox'].includes(environment)
const isDemo = ['demo'].includes(environment)
const isTest = ['test'].includes(environment)
const isDevelopment = ['dev'].includes(environment)

export function isProductionEnv(): boolean {
  return isProduction
}

export function isDevelopmentEnv(): boolean {
  return isDevelopment
}

export function isProductionOrDemoEnv(): boolean {
  return isProduction || isDemo
}

export function isSandboxEnv(): boolean {
  return isSandbox
}

export function isDemoEnv(): boolean {
  return isDemo
}

export function isTestEnv(): boolean {
  return isTest
}

/**
 * True when you're running the app yourself, off a dev server. Handy for
 * developer-only UI that should show up locally as well as on the dev
 * environment.
 *
 * The integration tests run off a dev server too, so they're excluded by hand.
 * Without that, a local test run would see dev-only UI that CI - which serves a
 * build - doesn't, and the same test would pass in one place and fail in the
 * other.
 */
export function isLocalDevelopmentEnv(): boolean {
  return import.meta.env.DEV && !isTest
}

export function getEnvironment(): SentryConfig['environment'] {
  return environment
}
